/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ActionDelete from '@material-ui/icons/Delete';
import { Button } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles/colorManipulator';

const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(),
  },
});

class DeletePreviewButton extends Component {
  handleClick = () => {
    this.props.previewRemoved(this.props.record);
  };

  render() {
    const { classes = {} } = this.props;

    return (
      <Button className={classes.deleteButton} onClick={this.handleClick}>
        <ActionDelete className={classes.extendedIcon} />
        Remove
      </Button>
    );
  }
}

DeletePreviewButton.defaultProps = {
  previewRemoved: () => {},
};

export default withStyles(styles)(DeletePreviewButton);
